<div class="export-modal-header">
  <h2 mat-dialog-title>Export Format</h2>
  <button mat-icon-button type="button" (click)="onClose()" aria-label="Close">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-divider></mat-divider>

<mat-dialog-content class="export-modal-content">
  <div class="export-modal-excel-row">
    <ng-container *ngIf="data.excelExportCallback; else defaultExcelExport">
      <button mat-flat-button class="mic-btn-icon-left" style="height: 48px; padding: 0 24px" (click)="onExcelExport()">
        <mat-icon>table_view</mat-icon> Excel
      </button>
    </ng-container>
    <ng-template #defaultExcelExport>
      <app-export-to-excel
        [columnNames]="selectedColumnNames"
        [dataFetcher]="data.dataFetcher"
        [fileName]="fileName"
        [extraColumns]="data.extraColumns"
        (exportStarted)="onSharedExcelExportStarted()"
      ></app-export-to-excel>
    </ng-template>
    <button
      *ngIf="data.pdfExportCallback"
      mat-flat-button
      class="mic-btn-icon-left"
      style="height: 48px; padding: 0 24px"
      (click)="onPdfExport()"
    >
      <mat-icon>picture_as_pdf</mat-icon> PDF
    </button>
  </div>

  <div *ngIf="data.maxExportRows" class="export-modal-limit-notice">
    {{ translationService.translate('onlyTheFirstNoteText') }} {{ data.maxExportRows | number }}
    {{ translationService.translate('recordsWillBeExportedText') }}
  </div>

  <div class="export-modal-actions-row">
    <span class="export-modal-fields-label">Fields to select</span>
    <button mat-flat-button type="button" color="primary" (click)="allSelected ? deselectAll() : selectAll()">
      {{ allSelected ? 'Deselect All' : 'Select All' }}
    </button>
  </div>

  <div class="export-modal-checkbox-list">
    <div *ngFor="let col of data.columns; let i = index" class="export-modal-checkbox-row">
      <mat-checkbox color="primary" [formControl]="columnsForm.controls[i]">
        {{ col.label }}
      </mat-checkbox>
    </div>
  </div>
</mat-dialog-content>

<mat-divider></mat-divider>

<mat-dialog-actions align="end" class="export-modal-dialog-actions">
  <button mat-button type="button" (click)="onClose()">Cancel</button>
</mat-dialog-actions>
